export default __webpack_public_path__ + "static/media/visa.cfa31470.svg";